import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';

import type { ReactCodeComponentModel } from '../../../../api/api';

type ReactComponentBindingInputProps = {
	componentId: string;
	componentName?: string;
	components: ReactCodeComponentModel[];
	onComponentNameChange: (componentName: string | undefined) => void;
};

export function ReactComponentBindingInput({ componentId, componentName, components, onComponentNameChange }: ReactComponentBindingInputProps) {
	const selectedName = componentName ?? '';
	const hostBoundComponent = components.find((candidate) => candidate.id === componentId);
	const selectedComponentExists = components.some((candidate) => candidate.name === selectedName);
	const sortedComponents = components.slice().sort((left, right) => left.name.localeCompare(right.name));

	return (
		<FormControl fullWidth size="small" variant="standard">
			<Select
				value={selectedName}
				displayEmpty
				onChange={(event) => onComponentNameChange(event.target.value || undefined)}
				inputProps={{ 'aria-label': 'React component' }}
			>
				<MenuItem value=""><em>Unassigned</em></MenuItem>
				{selectedName && !selectedComponentExists && (
					<MenuItem value={selectedName} disabled>
						{selectedName} (not found in React code)
					</MenuItem>
				)}
				{sortedComponents.map((candidate) => (
					<MenuItem key={candidate.id} value={candidate.name}>
						{candidate.name} — {candidate.entryPoint}
					</MenuItem>
				))}
			</Select>
			<FormHelperText>
				{selectedName
					? 'Uses the selected named component. This change is part of the App draft until saved.'
					: hostBoundComponent
						? `Bound to ${hostBoundComponent.name} (${hostBoundComponent.entryPoint}) by matching this host's ID. This change is part of the App draft until saved.`
						: 'Unassigned. An agent can create a component for this host using its ID. This change is part of the App draft until saved.'}
			</FormHelperText>
		</FormControl>
	);
}
